unit Simple.Dashboard.Return.Types;

interface

uses System.Generics.Collections {$IFDEF PAS2JS},JS{$ENDIF};

{$IFDEF PAS2JS}
function UnwrapXDataResultObject(AObject: TJSObject): TJSObject;
{$ENDIF}

type

{$SCOPEDENUMS ON}

{
When we start using Entities this should change to  TDashboardFormat = (Money,Number,Integer,Text,Image,Graph);
See XData-Core\Models\Dashboard\SMX.Dashboard.Entities
}
TDashboardResponseType = (NoResult, Money, Number, Integer, Text, Image, Graph, HTML);
//TDashboardValueScale = (None, Unitary,

{$IFNDEF PAS2JS}
[Enumeration(TEnumMappingType.emString,
    'Dec,Str,Int,Flt,AMPM,Month,CurrDec')]
{$ENDIF}
TDashboardFieldType = (Dec,Str,Int,Flt,AMPM,Month,CurrDec);


TSummaryArray = Class
  SearchName: string;
  ToField: string;
  AggregateFunction: string;
  AggregateStore: string;
  DisplayName: string;
  FieldType: string;

End;


TDashboardItemConfig = class
  private
  public
    //Title: string;
    YValueName: string;
    XValueLabels: string;
    //XFieldDisplay: string;
    LegendText: string;
    SummaryTablePresent: boolean;
    LegendData: TArray<String>;
    //ColumnHeadings: TArray<String>;
    SummaryRecordDisplay: integer;
    DrillDownFieldName: string;
    DrilDownSQL: string;
    Parameters: TArray<string>;
    SummaryFields: TArray<TSummaryArray>;
    {$IFDEF PAS2JS}
    procedure Assign(Source: TJSObject);
    {$ENDIF}
end;

TDashboardResponse = class
  private
    function GetItemType: TDashboardResponseType;
    procedure SetItemType(const Value: TDashboardResponseType);
  public
  ChartJson: String;
  Key: String;
  Description: String;
  Hint: String;
  ItemType: String;
  Scale: String;
  Expires: TDateTime;
  Title: string;
  Configuration: string;
  SummaryType: string;
  SummaryPresent: boolean;
  SummaryData: string;
  DrillDownPresent: boolean;
  DrillDownSQL: string;
  ChartType: string;
  ChartTypeFixed: boolean;
  FullSummaryAvailable: boolean;
//  ColumnHeadings: string;
//  ColumnList: string { TODO : for tables and garpahs: a csv list of column headers, which will also show how many columns there are }
  function AsFormatted(const AFormat: string = '#,##0'): string;
  {$IFDEF PAS2JS}
  function GetChartPayload: string;
  function GetSummaryPayload: string;
  procedure Assign(Source: TJSObject);
  {$ENDIF}
  property Item_Type: TDashboardResponseType read GetItemType write SetItemType;
//  property Value_Scale: TDashboardValueScale

end;

TDashboardSummaryDataResponse = class
  private

  protected

  public
    SummaryData: string;
    {$IFDEF PAS2JS}
    procedure Assign(Source: TJSObject);
    {$ENDIF}
end;

const
OUTSTANDING_CLAIMS = 'OUTSTANDING_CLAIMS';
DONATIONS_BY_MONTH = 'DONATIONS_BY_MONTH';
TOTAL_GIFTAID_CLAIMED = 'TOTAL_GIFTAID_CLAIMED';
CLAIMS_BREAKDOWN = 'CLAIMS_BREAKDOWN';
DONOR_COUNT = 'DONOR_COUNT';

implementation

uses System.Rtti, System.SysUtils;


{$SCOPEDENUMS OFF}

{ TDashboardResponse }

{ TDashboardResponse }

function TDashboardResponse.AsFormatted(const AFormat: string): string;
var
  lValue: Integer;
begin
  lValue := StrToIntDef(ChartJson, 0);
  Result := FormatFloat(AFormat, lValue);
end;

{$IFDEF PAS2JS}
function JsonFieldToString(AObject: TJSObject; const AProp: string): string;
begin
  Result := '';
  if not Assigned(AObject) then
    Exit;

  if TJSArray.isArray(TJSObject(AObject)[AProp]) then
    Result := string(TJSJSON.stringify(TJSArray(TJSObject(AObject)[AProp])))
  else if JS.isObject(TJSObject(AObject)[AProp]) then
    Result := string(TJSJSON.stringify(TJSObject(AObject)[AProp]))
  else
    Result := string(TJSObject(AObject)[AProp]);
end;

function JsonResponsePropertyToString(AObject: TJSObject; const AProp: string): string;
var
  lLowerProp: string;
begin
  Result := JsonFieldToString(AObject, AProp);
  if Result <> '' then
    Exit;

  lLowerProp := LowerCase(Copy(AProp, 1, 1)) + Copy(AProp, 2, MaxInt);
  if lLowerProp <> AProp then
    Result := JsonFieldToString(AObject, lLowerProp);
end;

function JsonResponsePropertyToBool(AObject: TJSObject; const AProp: string): Boolean;
var
  lRaw: string;
begin
  lRaw := Trim(JsonResponsePropertyToString(AObject, AProp));
  if lRaw <> '' then
    Result := (LowerCase(lRaw) = 'true') or (lRaw = '1')
  else
    Result := boolean(TJSObject(AObject)[AProp]);
end;

function JsonResponsePropertyToScalar(AObject: TJSObject; const AProp: string): string;
begin
  Result := JsonResponsePropertyToString(AObject, AProp);
end;

function UnwrapXDataResultObject(AObject: TJSObject): TJSObject;
var
  lInner: TJSObject;
begin
  Result := AObject;
  if not Assigned(AObject) then
    Exit;

  lInner := TJSObject(TJSObject(AObject)['value']);
  if not Assigned(lInner) then
    Exit;

  if (Trim(JsonResponsePropertyToString(AObject, 'ChartJson')) = '') and
     (Trim(JsonResponsePropertyToString(AObject, 'SummaryData')) = '') and
     (Trim(JsonResponsePropertyToString(AObject, 'Value')) = '') and
     (Trim(JsonResponsePropertyToString(AObject, 'value')) = '') then
    Result := lInner;
end;

function TDashboardResponse.GetChartPayload: string;
begin
  Result := Trim(ChartJson);
  if (Result = '') or (Result = '[]') then
    Result := Trim(SummaryData);
end;

function TDashboardResponse.GetSummaryPayload: string;
begin
  Result := Trim(SummaryData);
  if (Result = '') or (Result = '[]') then
    Result := Trim(ChartJson);
end;

procedure TDashboardResponse.Assign(Source: TJSObject);
begin
  ChartJson := JsonResponsePropertyToString(Source, 'ChartJson');
  if ChartJson = '' then
    ChartJson := JsonResponsePropertyToString(Source, 'chartJson');
  if ChartJson = '' then
    ChartJson := JsonResponsePropertyToString(Source, 'Value');
  if ChartJson = '' then
    ChartJson := JsonResponsePropertyToString(Source, 'value');
  Key := JsonResponsePropertyToScalar(Source, 'Key');
  Description := JsonResponsePropertyToScalar(Source, 'Description');
  Hint := JsonResponsePropertyToScalar(Source, 'Hint');
  ItemType := JsonResponsePropertyToScalar(Source, 'ItemType');
  Scale := JsonResponsePropertyToScalar(Source, 'Scale');
  if Trim(string(TJSObject(Source)['Expires'])) <> '' then
    Expires := TDateTime(TJSObject(Source)['Expires'])
  else
    Expires := 0;
  Title := JsonResponsePropertyToScalar(Source, 'Title');
  Configuration := JsonResponsePropertyToString(Source, 'Configuration');
  SummaryData := JsonResponsePropertyToString(Source, 'SummaryData');
  if SummaryData = '' then
    SummaryData := JsonResponsePropertyToString(Source, 'summaryData');
  SummaryType := JsonResponsePropertyToScalar(Source, 'SummaryType');
  SummaryPresent := JsonResponsePropertyToBool(Source, 'SummaryPresent');
  DrillDownPresent := JsonResponsePropertyToBool(Source, 'DrillDownPresent');
  // Drill-down widgets (e.g. Department Ranking) send chart rows and summary
  // rows separately. Never mirror chart JSON into an explicit empty summary.
  if DrillDownPresent then
  begin
    if (Trim(SummaryData) = '') then
      SummaryData := '[]';
  end
  else if (Trim(SummaryData) = '') or (SummaryData = '[]') then
    SummaryData := ChartJson;
  if (Trim(ChartJson) = '') or (ChartJson = '[]') then
    ChartJson := SummaryData;
  DrillDownSQL := JsonResponsePropertyToScalar(Source, 'DrillDownSQL');
  if DrillDownSQL = '' then
    DrillDownSQL := JsonResponsePropertyToScalar(Source, 'DrilDownSQL');
  ChartType := JsonResponsePropertyToScalar(Source, 'ChartType');
  ChartTypeFixed := JsonResponsePropertyToBool(Source, 'ChartTypeFixed');
  FullSummaryAvailable := JsonResponsePropertyToBool(Source, 'FullSummaryAvailable');
end;
{$ENDIF}

function TDashboardResponse.GetItemType: TDashboardResponseType;
begin
  Result := TRttiEnumerationType.GetValue<TDashboardResponseType>(ItemType);
end;

procedure TDashboardResponse.SetItemType(const Value: TDashboardResponseType);
begin
  ItemType := TRttiEnumerationType.GetName<TDashboardResponseType>(Value);
end;

{$IFDEF PAS2JS}
procedure TDashboardItemConfig.Assign(Source: TJSObject);
var
  lSummaryFields: TJSArray;
  lIdx: Integer;
  lFieldObj: TJSObject;
  lField: TSummaryArray;
begin
  YValueName := JsonResponsePropertyToString(Source, 'YValueName');
  XValueLabels := JsonResponsePropertyToString(Source, 'XValueLabels');

  LegendText := JsonResponsePropertyToScalar(Source, 'LegendText');
  SummaryTablePresent := JsonResponsePropertyToBool(Source, 'SummaryTablePresent');
  LegendData := TArray<String>(TJSObject(Source)['LegendData']);
  DrillDownFieldName := JsonResponsePropertyToScalar(Source, 'DrillDownFieldName');
  DrilDownSQL := JsonResponsePropertyToScalar(Source, 'DrilDownSQL');
  Parameters := TArray<string>(TJSObject(Source)['Parameters']);

  SetLength(SummaryFields, 0);
  lSummaryFields := TJSArray(TJSObject(Source)['SummaryFields']);
  if not Assigned(lSummaryFields) then
    lSummaryFields := TJSArray(TJSObject(Source)['summaryFields']);
  if Assigned(lSummaryFields) then
  begin
    SetLength(SummaryFields, lSummaryFields.Length);
    for lIdx := 0 to lSummaryFields.Length - 1 do
    begin
      lField := TSummaryArray.Create;
      lFieldObj := TJSObject(lSummaryFields[lIdx]);
      lField.SearchName := string(lFieldObj['SearchName']);
      lField.ToField := string(lFieldObj['ToField']);
      lField.AggregateFunction := string(lFieldObj['AggregateFunction']);
      lField.AggregateStore := string(lFieldObj['AggregateStore']);
      lField.DisplayName := string(lFieldObj['DisplayName']);
      lField.FieldType := string(lFieldObj['FieldType']);
      SummaryFields[lIdx] := lField;
    end;
  end;

  if Length(SummaryFields) = 0 then
  begin
    lSummaryFields := TJSArray(TJSObject(Source)['ColumnHeadings']);
    if Assigned(lSummaryFields) then
    begin
      SetLength(SummaryFields, lSummaryFields.Length);
      for lIdx := 0 to lSummaryFields.Length - 1 do
      begin
        lField := TSummaryArray.Create;
        lField.SearchName := string(lSummaryFields[lIdx]);
        lField.ToField := lField.SearchName;
        lField.DisplayName := StringReplace(lField.SearchName, '_', ' ', [rfReplaceAll]);
        lField.FieldType := 'Str';
        SummaryFields[lIdx] := lField;
      end;
    end;
  end;
end;
{$ENDIF}

{$IFDEF PAS2JS}
procedure TDashboardSummaryDataResponse.Assign(Source: TJSObject);
begin
  SummaryData := JsonResponsePropertyToString(Source, 'SummaryData');
end;
{$ENDIF}


end.
